var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 45C17.25 45 15.025 47.25 15.025 50C15.025 52.75 17.25 55 20 55C22.75 55 25 52.75 25 50C25 47.25 22.75 45 20 45ZM5 5V10H10L19 28.975L15.625 35.1C15.225 35.8 15 36.625 15 37.5C15 40.25 17.25 42.5 20 42.5H50V37.5H21.05C20.7 37.5 20.425 37.225 20.425 36.875L20.5 36.575L22.75 32.5H41.375C43.25 32.5 44.9 31.475 45.75 29.925L54.7 13.7C54.9 13.35 55 12.925 55 12.5C55 11.125 53.875 10 52.5 10H15.525L13.175 5H5ZM45 45C42.25 45 40.025 47.25 40.025 50C40.025 52.75 42.25 55 45 55C47.75 55 50 52.75 50 50C50 47.25 47.75 45 45 45Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/Shopping_cart.e12af524fab59edb911b8f9f2025e162.svg";
export { ForwardRef as ReactComponent };